import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useGalleryThemeVariables } from '../../lib/galleryCustomisation';
import { cn } from '../../lib/utils';
import { Button } from './Button';

export const Dialog = RadixDialog.Root;
export const DialogTrigger = RadixDialog.Trigger;

export function DialogContent({
  title,
  description,
  className,
  children
}: {
  title: string;
  description?: string;
  className?: string;
  children: React.ReactNode;
}) {
  const galleryTheme = useGalleryThemeVariables();
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="fixed inset-0 z-40 bg-black/55 backdrop-blur-[2px]" />
      <RadixDialog.Content
        style={galleryTheme ?? undefined}
        className={cn(
          'fixed left-1/2 top-1/2 z-50 max-h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-sm border border-ink/15 bg-ivory p-5 shadow-soft outline-none sm:p-6',
          galleryTheme && 'client-gallery-dialog',
          className
        )}
      >
        <div className="mb-5 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <RadixDialog.Title className="text-xl font-semibold text-ink">{title}</RadixDialog.Title>
            {description ? <RadixDialog.Description className="mt-1 text-sm text-ink/70">{description}</RadixDialog.Description> : null}
          </div>
          <RadixDialog.Close asChild>
            <Button variant="ghost" size="icon" aria-label="Close dialog">
              <X className="h-4 w-4" />
            </Button>
          </RadixDialog.Close>
        </div>
        {children}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}
